import { makeStyles } from '@material-ui/styles'
import { styled, withStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import FormControlLabel from '@material-ui/core/FormControlLabel'

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  heading: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1.5),
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.primary.light,
    backgroundColor: theme.palette.primary.selected,
    borderRadius: 40,
    minWidth: 40,
    minHeight: 40,
  },
  mainWrapper: {
    textDecoration: 'none',
  },
  action: {
    marginLeft: 'auto',
    paddingRight: theme.spacing(2),
    [theme.breakpoints.only('xs')]: {
      paddingRight: 0,
    },
    color: 'rgba(0, 0, 0, 0.54)',
  },
  adornedEnd: {
    paddingRight: '8px',
    '& button': {
      padding: 0,
    },
  },
  settingsCaption: {
    marginLeft: theme.spacing(2),
    '& p': {
      color: 'rgba(0, 0, 0, 0.54)',
    },
  },
  settingsWrapper: {
    display: 'flex',
    alignItems: 'center',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 12,
    padding: '24px 8px 24px 24px',
    color: 'rgba(0, 0, 0, 0.87)',
    minHeight: theme.spacing(9),
    [theme.breakpoints.only('xs')]: {
      minHeight: theme.spacing(12),
    },
  },
  settingsDescription: {
    '& p': {
      color: 'rgba(0, 0, 0, 0.54)',
    },
  },
  clickable: {
    cursor: 'pointer',
  },
  settingsText: {
    marginLeft: theme.spacing(7),
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(7),
    width: '80%',
  },
  linkButton: {
    paddingLeft: 0,
    color: theme.palette.primary.main,
    textTransform: 'none',
    justifyContent: 'start',
    textAlign: 'left',
  },
  contentContainer: {
    margin: '2rem auto 6rem',
    maxWidth: 832,
    padding: theme.spacing(0, 2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(0, 1),
      gap: theme.spacing(2.5),
    },
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
  sectionEyebrow: {
    margin: 0,
    fontSize: '0.6875rem',
    fontWeight: 600,
    letterSpacing: '0.08em',
    lineHeight: 1.3,
    textTransform: 'uppercase',
    color: '#6B7C87',
  },
  sectionSubtitle: {
    margin: theme.spacing(0.5, 0, 0),
    fontSize: '0.8125rem',
    lineHeight: 1.4,
    color: theme.palette.text.secondary,
  },
  card: {
    border: '1px solid #E0E0E0',
    borderRadius: 12,
    backgroundColor: '#FFFFFF',
    overflow: 'hidden',
    '& > * + *': {
      borderTop: '1px solid #E0E0E0',
    },
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 2.5),
    textDecoration: 'none',
    color: 'inherit',
    width: '100%',
    boxSizing: 'border-box',
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1.75, 2),
      gap: theme.spacing(1.5),
    },
  },
  rowButton: {
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    textAlign: 'left',
    font: 'inherit',
  },
  accountLink: {
    textDecoration: 'none',
    color: 'inherit',
    display: 'block',
  },
  accountAvatar: {
    width: 48,
    height: 48,
    flexShrink: 0,
  },
  toggleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 2.5),
    width: '100%',
    boxSizing: 'border-box',
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1.75, 2),
      gap: theme.spacing(1.5),
    },
  },
  nestedToggleRow: {
    paddingLeft: theme.spacing(6),
    paddingRight: theme.spacing(6),
    [theme.breakpoints.down('xs')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },
  rowBody: {
    flex: 1,
    minWidth: 0,
  },
  rowTitle: {
    margin: 0,
    fontSize: '0.9375rem',
    fontWeight: 600,
    lineHeight: 1.3,
    color: '#172024',
  },
  rowDescription: {
    margin: theme.spacing(0.5, 0, 0),
    fontSize: '0.8125rem',
    lineHeight: 1.4,
    color: theme.palette.text.secondary,
  },
  rowTrailing: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexShrink: 0,
  },
  rowIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 32,
    height: 32,
    flexShrink: 0,
    borderRadius: '50%',
    backgroundColor: '#EBF0F2',
    color: '#172024',
    '& .MuiSvgIcon-root': {
      fontSize: 16,
    },
    '& svg': {
      width: 16,
      height: 16,
    },
  },
  chevron: {
    color: 'rgba(0, 0, 0, 0.38)',
    fontSize: 20,
  },
  optionCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 2.5),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1.75, 2),
    },
  },
  optionHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(2),
  },
  optionControl: {
    paddingLeft: theme.spacing(6),
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 0,
    },
  },
  choiceRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 2.5),
    width: '100%',
    boxSizing: 'border-box',
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1.75, 2),
      gap: theme.spacing(1.5),
    },
  },
  choiceTitleRow: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },
  choiceRadioRoot: {
    flexShrink: 0,
    padding: theme.spacing(0.5),
    color: '#40484C',
    pointerEvents: 'none',
  },
  choiceRadioChecked: {
    color: '#0053FF',
  },
  choiceCheckboxRoot: {
    flexShrink: 0,
    padding: theme.spacing(0.5),
    color: '#40484C',
  },
  choiceCheckboxChecked: {
    color: '#0053FF',
  },
  statusBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: theme.spacing(0.375, 1),
    borderRadius: 999,
    fontSize: '0.6875rem',
    fontWeight: 400,
    lineHeight: 1.2,
    whiteSpace: 'nowrap',
    backgroundColor: '#EBF0F2',
    color: '#172024',
  },
  tipBannerWrapper: {
    padding: theme.spacing(0, 2.5, 2),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(0, 2, 1.75),
    },
  },
  tipBanner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    padding: theme.spacing(1.5, 2),
    borderRadius: 12,
    backgroundColor: '#E8EFFF',
    border: '1px solid #B8CCFF',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },
  tipBannerCopy: {
    flex: 1,
    minWidth: 0,
  },
  tipBannerText: {
    fontSize: '0.8125rem',
    lineHeight: 1.4,
    color: '#172024',
  },
  tipBannerButton: {
    flexShrink: 0,
    borderRadius: 100,
    textTransform: 'none',
    boxShadow: 'none',
    whiteSpace: 'nowrap',
  },
}))

// Kept for settings/index.js until the settings pages redesign lands in PR 2.
export const SettingsBlock = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'left',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 12,
  padding: '24px 8px 24px 24px',
  color: 'rgba(0, 0, 0, 0.87)',
  minHeight: theme.spacing(9),
}))

export const SettingsFormControlLabel = withStyles(theme => ({
  label: { marginLeft: theme.spacing(1) },
}))(FormControlLabel)

export default useStyles
